import Size from "../file-size";
import { InputFile } from "../file-classes";

const accept = ({ accept }, file) => {
    if (accept) {
        const thisExt = new InputFile(file).extension;
        const extensions = accept.split(",").reduce((result, current) => {
            const e = current.trim().toLowerCase();
            if (e.length > 1 && e.substring(0, 1) === ".") {
                result.push(e.substring(1));
            }
            return result;
        }, []);
        if (!extensions.includes(thisExt)) {
            throw new Error(
                `File type ${thisExt} not supported, accepted types ${accept}`
            );
        }
    }
    return file;
};

const maximumSize = ({ maxFileSize: max }, file) => {
    if (max && Size.Mb(file) > parseFloat(max)) {
        throw new Error(`Please use a smaller file size (max ${max}MB).`);
    }
    return file;
};

export { accept, maximumSize };
